
import { useCallback, useEffect, useState } from "react"
import { usePagination } from "../../hooks/usePagination"
import Table from "../table/Table"
import LeftIcon from "../svg/LeftButton"
import RightIcon from "../svg/RightIcon"
import { Button, Label } from "reactstrap"
import DateTimePicker from 'react-datepicker'
import Breadcrumbs from "../../coreComponents/breadcrumbs"
import { useNavigate } from "react-router-dom"
import { format } from "date-fns"
import ApiService from "../../services/apiService"
import { method } from "lodash"
import ExportExcel from "../reports/ExportExcel"
import { toast } from "react-toastify"
const AllWuaReport =() =>{
    const  [fromDateTime,setFromDateTime]=useState<any>()
    const [toDateTime,setToDateTime]=useState<any>()
    const [isEnabled,setIsEnabled] = useState<any>()
    const [summaryData,setSummaryData] = useState<any>()
    const [unitPrice,setUnitPrice] = useState()
    const [refreshKey, setRefreshKey] = useState(0);
    const navigate = useNavigate();
   
         
       const {
           data,
           setFromDate,
           setToDate,
           pageNumber,
           pageSize,setPageNumber,
           totalCount,
           fromDate,
           toDate,
           setRefresh
   
   
        } = usePagination({
            endpoint: `/wuareport/getreportbydate`,
            enabled:isEnabled,
            refreshKey
       })     
          const totalPages = Math.ceil(totalCount / pageSize);
   
       const handleNext = useCallback(() => {
           setPageNumber((prev) => Math.min(totalPages, prev + 1))
       }, [setPageNumber, totalPages])
   
   
   
       const handlePrev = useCallback(() => {
           setPageNumber((prev) => Math.max(1, prev - 1))
       }, [setPageNumber, totalPages])
      
       const handleClick = () =>{
        if (!validateGenerate()) return;
           if(fromDateTime){
                const from = format(fromDateTime, 'yyyy-MM-dd HH:mm:ss');
                setFromDate(from);
           }
           if(toDateTime){
                const to = format(toDateTime, 'yyyy-MM-dd HH:mm:ss');
                setToDate(to);
           }
           setIsEnabled(true);
           setRefreshKey(prev => prev + 1); // Force API re-fetch
           setPageNumber(1); 
       }
   
       const getWaterCharges = async() =>{
           try{
               const response = await ApiService.axiosApi(`/watercharges/bydate/${fromDate}`,{
                   method:'GET'
               })
               if(response.success){
                   setUnitPrice(response.data.unitPrice)
               }else{
                  console.log('no unit price')
               }
           }catch(e){
               console.log(e)
           }
        }
   
        useEffect(()=>{
           getWaterCharges();
        },[fromDate])

        const fectWuaReport = async() =>{
         
            try{
                 const response = await ApiService.axiosApi(`/wuareport/getreportbydate`,{
                     method:'GET',
                     params:{
                         
                         pageNumber:0,
                         pageSize:0,
                         FromDate:format(fromDateTime, 'yyyy-MM-dd HH:mm:ss'),
                         ToDate:format(toDateTime, 'yyyy-MM-dd HH:mm:ss')
    
                     }
                 })
    
                 if(response.success){
                     return response.data.data
                 }else{
                     console.log("uanable to get wua report")
                 }
            }catch(e){
                 console.log(e)
            }
             
         }

         const validateGenerate = () => {
           
            
          
            if (!fromDateTime) {
              toast.warning("Please select From Date");
              return false;
            }
          
            if (!toDateTime) {
              toast.warning("Please select To Date");
              return false;
            }
          
            if (new Date(fromDateTime) > new Date(toDateTime)) {
              toast.warning("From Date cannot be greater than To Date");
              return false;
            }
          
            return true;
          };
   

    return(
        <>
           <Breadcrumbs mainTitle="WUA Water Distribution" parent="WUA Report" />
            <div className='w-100 bg-white px-2 py-2'>
                <div className='bg-light-primary d-flex justify-content-around align-items-center'
                    style={{
                        width: '100%',
                        height: '100px',
                        border: '1px solid rgb(43, 94, 94, 0.1)',
                    }}>

                

                    <div className="report-input-div mx-4 input-border d-flex flex-column ">
                        <Label>From Date:</Label>
                        <DateTimePicker
                            className="report-input"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD-MM-YYYY"
                           
                            onChange={(date: any) => setFromDateTime(date)}
                            selected={fromDateTime}
                            isClearable
                          
                        />
                    </div>


                    <div className="report-input-div mx-4  input-border  d-flex flex-column">
                        <Label>To Date:</Label>
                        <DateTimePicker
                            className="report-input"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD-MM-YYYY"
                           
                            onChange={(date: any) => setToDateTime(date)}
                            selected={toDateTime}
                            isClearable
                           
                        />
                    </div>

                    <div className=" d-flex flex-column" style={{width:'8%'}}>
                        <Label style={{ visibility: 'hidden' }}>Generate</Label>
                        <Button className="px-0" color="success" onClick={handleClick}   style={{
                 width:'100%', whiteSpace: 'nowrap',
                 overflow: 'hidden',
                 textOverflow: 'ellipsis' 
              }}>
                            Generate
                        </Button>
                    </div>
                       
                       <div style={{width:'8%'}}>
                    <Label style={{ visibility: 'hidden' }}>Generate</Label>
                        <ExportExcel
                         getData={fectWuaReport}
                         fileName='Wua_Water_Distribution_Report'
                         unitPrice={unitPrice}
                         EffectiveFrom={fromDate}
                         toDate={toDate}
                         hiddenColumns={['wuaId','dateTime','id']}
                         columnHeaderMap={{
                            headQuaterName:'Wua',
                            areaInCCA_HA:'Area Covered In HAC',
                            totalWaterDischargeInleters:'Total Water Distributed (liters)',
                           
                            
                          }}
                          columnOrder={['headQuaterName','chakArea','totalWaterDistrubuted']}
                         
                        />
                     </div>

                    

                </div>


                <div className='mt-2'>
                   <Table
                        isAction={false}
                        data={data}
                        columns={[
                  
                            { header: "WUA", accessor: 'headQuaterName' },
                            { header: 'Total CCA_HA', accessor: 'chakArea' },
                            {header:'Total Water Discharge(m³)',accessor:'totalWaterDistrubuted'},
                            
                           
                        ]}

                        buttons={[
                            
                        ]}
                    /> 
                   {(!data || data.length === 0) && (
    <div className="d-flex justify-content-center py-3 text-muted">
        No data available
    </div>
)}

                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>
                </div>



               
            </div>
        </>
    )
}

export default AllWuaReport;